import TagManager from "react-gtm-module";

function ExploreCollegesMajor({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "explore_colleges_major",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default ExploreCollegesMajor;
